/*
 * Die Anwendertexte der Vorgangsabschnitte (Spec „Abschnittsmuster der Vorgangsdialoge“, Tabelle „Anwendung auf die drei
 * Vorgangsdialoge“; Hausregel „Texte in Properties“): Schlüssel englisch, Werte deutsch. Die Masken schreiben keinen
 * Abschnittstitel selbst.
 */

const head = "Kopfdaten";
const untitled = "ohne Titel";
const empty = "leer";
/** Trenner der Teile einer Zusammenfassung. */
const SEP = " · ";

export const SECTION_TEXT = {
  /** Die Zusammenfassung eines zugeklappten Abschnitts ohne Inhalt. */
  empty,
  head,
  parties: "Parteien",
  term: "Laufzeit und Kündigung",
  payment: "Zahlungsvereinbarung",
  paymentOrder: "Zahlungsvereinbarung und Fälligkeiten",
  billingSources: "Abrechnungsquellen",
  billingVolume: "Abrechnung und Volumen",
  note: "Notiz",
  intro: "Einleitungstext",
  items: "Positionen",
  outro: "Ausleitungstext",
  textAttachments: "Anlagen aus Textbausteinen",
  files: "Dateien",
  versions: "Versionen",
  /** Der Kopfblock trägt den Titel des Vorgangs im Namen; ein leerer Titel wäre eine Tür ohne Schild. */
  headTitle: (titel: string): string => `${head}: ${titel.trim() === "" ? untitled : titel}`,
  /** Die Zusammenfassung der Kopfdaten: Betrag ZUERST (Ruling 506) — me-abschnitt kürzt einzeilig am Ende, so fällt nie
   *  die Zahl weg. */
  headSummary: (betrag: string, label: string): string => `${betrag}${SEP}${label}`,
  /** Die kurzen Labels hinter dem Nettobetrag der Kopfdaten (ohne bzw. mit Positionen). */
  net: "Netto",
  netComputed: "Netto, berechnet",
  /** „24 Monate · Kündigung 3 Monate“ — je Teil nur, wenn er angegeben ist, sonst „leer“. */
  termSummary: (laufzeit: string | null, frist: string | null): string =>
    [laufzeit, frist === null ? null : `Kündigung ${frist}`].filter((t) => t !== null).join(SEP) || empty,
  /** Die Zahl der Raten einer Zahlungsvereinbarung, ohne Raten „leer“. */
  rates: (zahl: number): string => (zahl === 0 ? empty : zahl === 1 ? "1 Rate" : `${String(zahl)} Raten`),
} as const;
